import React from 'react';
import { useLanguage } from '../lib/i18n';
export function LanguageSwitcher() {
  const {
    lang,
    setLang
  } = useLanguage();
  return <div className="flex items-center gap-2 text-[10px] tracking-[0.2em] font-medium" data-id="element-219" data-mp="3hnu3nwichhiv">
      <button onClick={() => setLang('es')} className={`transition-colors duration-300 ${lang === 'es' ? 'text-terracotta font-bold' : 'text-volcanic/60 hover:text-volcanic'}`} data-id="element-220" data-mp="3mllusob60zm0">
        ES
      </button>
      <span className="text-volcanic/30" data-id="element-221" data-mp="3vmtjcenvqm2w">|</span>
      <button onClick={() => setLang('en')} className={`transition-colors duration-300 ${lang === 'en' ? 'text-terracotta font-bold' : 'text-volcanic/60 hover:text-volcanic'}`} data-id="element-222" data-mp="4g8xd9com4cq">
        EN
      </button>
    </div>;
}